
import { useEffect, useState } from 'react';
import { useRoyaltyReport } from '@/hooks/useRoyaltyReports';
import { useQuarterlyReports } from '@/hooks/useQuarterlyReports';

interface GroupedReport {
  authorId: string;
  year: number;
  quarter: number;
  reports: any[];
  totalSales: number;
  totalAmount: number;
  status: string;
  countries: Set<string>;
}

export const useReportGroup = (id: string) => {
  const [reportGroup, setReportGroup] = useState<GroupedReport | null>(null);
  
  const { data: report, isLoading } = useRoyaltyReport(id);
  
  const { data: quarterlyReports } = useQuarterlyReports(
    report?.authorId || '', 
    report?.year || 0, 
    report?.quarter || 0
  );

  useEffect(() => {
    if (report && quarterlyReports) {
      const currentQuarterReports = quarterlyReports.filter(r => 
        r.quarter === report.quarter && r.year === report.year
      );

      const reportsToUse = currentQuarterReports.length > 0 ? currentQuarterReports : [report];
      
      const totalSales = reportsToUse.reduce((sum, r) => sum + (r.unitsSold || r.salesCount || 0), 0);
      const totalAmount = reportsToUse.reduce((sum, r) => sum + (r.royaltyAmount || r.amount || 0), 0);
      const countries = new Set(reportsToUse.map(r => r.country || 'US'));

      const group: GroupedReport = {
        authorId: report.authorId,
        year: report.year,
        quarter: report.quarter,
        reports: reportsToUse,
        totalSales,
        totalAmount,
        status: report.status,
        countries
      };

      setReportGroup(group);
    }
  }, [report, quarterlyReports]);

  return { reportGroup, report, isLoading };
};
